import { createSelector } from "reselect";
import { AppState } from "../rootReducer";

// source list 

const getJobListPending = (state: AppState) => state.jobs.pending;
const getJobList = (state: AppState) => state.jobs.jobs;
const getJobListError = (state: AppState) => state.jobs.error;

export const getJobListSelector = createSelector(getJobList, (jobs) => jobs);
export const getJobListPendingSelector = createSelector(getJobListPending,(pending) => pending);
export const getJobListErrorSelector = createSelector(getJobListError, (error) => error);

